/* 🤖 this file was generated by svg-to-ts */

export type MatIconName =
  | '10-k'
  | '10-mp'
  | '11-mp'
  | '12-mp'
  | '13-mp'
  | '14-mp'
  | '15-mp'
  | '16-mp'
  | '17-mp'
  | '18-up-rating'
  | '18-mp'
  | '19-mp'
  | '1-k-plus'
  | '1-k'
  | '1-x-mobiledata'
  | '20-mp'
  | '21-mp'
  | '22-mp'
  | '23-mp'
  | '24-mp'
  | '2-k-plus'
  | '2-k'
  | '2-mp'
  | '30-fps-select'
  | '30-fps'
  | '3-d-rotation'
  | '3-g-mobiledata'
  | '3-k-plus'
  | '3-k'
  | '3-mp'
  | '3-p'
  | '4-g-mobiledata'
  | '4-g-plus-mobiledata'
  | '4-k-plus'
  | '4-k'
  | '4-mp'
  | '5-g'
  | '5-k-plus'
  | '5-k'
  | '5-mp'
  | '6-ft-apart'
  | '60-fps-select'
  | '60-fps'
  | '6-k-plus'
  | '6-k'
  | '6-mp'
  | '7-k-plus'
  | '7-k'
  | '7-mp'
  | '8-k-plus'
  | '8-k'
  | '8-mp'
  | '9-k-plus'
  | '9-k'
  | '9-mp'
  | 'abc'
  | 'ac-unit'
  | 'access-alarm'
  | 'access-alarms'
  | 'access-time-filled'
  | 'access-time'
  | 'accessibility-new'
  | 'accessibility'
  | 'accessible-forward'
  | 'accessible'
  | 'account-balance-wallet'
  | 'account-balance'
  | 'account-box'
  | 'account-circle'
  | 'account-tree'
  | 'ad-units'
  | 'adb'
  | 'add-a-photo'
  | 'add-alarm'
  | 'add-alert'
  | 'add-box'
  | 'add-business'
  | 'add-card'
  | 'add-chart'
  | 'add-circle-outline'
  | 'add-circle'
  | 'add-comment'
  | 'add-home-work'
  | 'add-home'
  | 'add-ic-call'
  | 'add-link'
  | 'add-location-alt'
  | 'add-location'
  | 'add-moderator'
  | 'add-photo-alternate'
  | 'add-reaction'
  | 'add-road'
  | 'add-shopping-cart'
  | 'add-task'
  | 'add-to-drive'
  | 'add-to-home-screen'
  | 'add-to-photos'
  | 'add-to-queue'
  | 'add'
  | 'addchart'
  | 'adf-scanner'
  | 'adjust'
  | 'admin-panel-settings'
  | 'ads-click'
  | 'agriculture'
  | 'air'
  | 'airline-seat-flat-angled'
  | 'airline-seat-flat'
  | 'airline-seat-individual-suite'
  | 'airline-seat-legroom-extra'
  | 'airline-seat-legroom-normal'
  | 'airline-seat-legroom-reduced'
  | 'airline-seat-recline-extra'
  | 'airline-seat-recline-normal'
  | 'airline-stops'
  | 'airlines'
  | 'airplane-ticket'
  | 'airplanemode-active'
  | 'airplanemode-inactive'
  | 'airplay'
  | 'airport-shuttle'
  | 'alarm-add'
  | 'alarm-off'
  | 'alarm-on'
  | 'alarm'
  | 'album'
  | 'align-horizontal-center'
  | 'align-horizontal-left'
  | 'align-horizontal-right'
  | 'align-vertical-bottom'
  | 'align-vertical-center'
  | 'align-vertical-top'
  | 'all-inbox'
  | 'all-inclusive'
  | 'all-out'
  | 'alt-route'
  | 'alternate-email'
  | 'analytics'
  | 'anchor'
  | 'android'
  | 'animation'
  | 'announcement'
  | 'aod'
  | 'apartment'
  | 'api'
  | 'app-blocking'
  | 'app-registration'
  | 'app-settings-alt'
  | 'app-shortcut'
  | 'approval'
  | 'apps-outage'
  | 'apps'
  | 'architecture'
  | 'archive'
  | 'area-chart'
  | 'arrow-back-ios-new'
  | 'arrow-back-ios'
  | 'arrow-back'
  | 'arrow-circle-down'
  | 'arrow-circle-left'
  | 'arrow-circle-right'
  | 'arrow-circle-up'
  | 'arrow-downward'
  | 'arrow-drop-down-circle'
  | 'arrow-drop-down'
  | 'arrow-drop-up'
  | 'arrow-forward-ios'
  | 'arrow-forward'
  | 'arrow-left'
  | 'arrow-outward'
  | 'arrow-right-alt'
  | 'arrow-right'
  | 'arrow-upward'
  | 'art-track'
  | 'article'
  | 'aspect-ratio'
  | 'assessment'
  | 'assignment-ind'
  | 'assignment-late'
  | 'assignment-return'
  | 'assignment-returned'
  | 'assignment-turned-in'
  | 'assignment'
  | 'assist-walker'
  | 'assistant-direction'
  | 'assistant-photo'
  | 'assistant'
  | 'assured-workload'
  | 'atm'
  | 'attach-email'
  | 'attach-file'
  | 'attach-money'
  | 'attachment'
  | 'attractions'
  | 'attribution'
  | 'audio-file'
  | 'audiotrack'
  | 'auto-awesome-mosaic'
  | 'auto-awesome-motion'
  | 'auto-awesome'
  | 'auto-delete'
  | 'auto-fix-high'
  | 'auto-fix-normal'
  | 'auto-fix-off'
  | 'auto-graph'
  | 'auto-mode'
  | 'auto-stories'
  | 'autofps-select'
  | 'autorenew'
  | 'av-timer'
  | 'baby-changing-station'
  | 'back-hand'
  | 'backpack'
  | 'backspace'
  | 'backup-table'
  | 'backup'
  | 'badge'
  | 'bakery-dining'
  | 'balance'
  | 'balcony'
  | 'ballot'
  | 'bar-chart'
  | 'batch-prediction'
  | 'bathroom'
  | 'bathtub'
  | 'battery-0-bar'
  | 'battery-1-bar'
  | 'battery-2-bar'
  | 'battery-3-bar'
  | 'battery-4-bar'
  | 'battery-5-bar'
  | 'battery-6-bar'
  | 'battery-alert'
  | 'battery-charging-full'
  | 'battery-full'
  | 'battery-saver'
  | 'battery-std'
  | 'battery-unknown'
  | 'beach-access'
  | 'bed'
  | 'bedroom-baby'
  | 'bedroom-child'
  | 'bedroom-parent'
  | 'bedtime-off'
  | 'bedtime'
  | 'beenhere'
  | 'bento'
  | 'bike-scooter'
  | 'biotech'
  | 'blender'
  | 'blind'
  | 'blinds-closed'
  | 'blinds'
  | 'block'
  | 'bloodtype'
  | 'bluetooth-audio'
  | 'bluetooth-connected'
  | 'bluetooth-disabled'
  | 'bluetooth-drive'
  | 'bluetooth-searching'
  | 'bluetooth'
  | 'blur-circular'
  | 'blur-linear'
  | 'blur-off'
  | 'blur-on'
  | 'bolt'
  | 'book-online'
  | 'book'
  | 'bookmark-add'
  | 'bookmark-added'
  | 'bookmark-border'
  | 'bookmark-remove'
  | 'bookmark'
  | 'bookmarks'
  | 'border-all'
  | 'border-bottom'
  | 'border-clear'
  | 'border-color'
  | 'border-horizontal'
  | 'border-inner'
  | 'border-left'
  | 'border-outer'
  | 'border-right'
  | 'border-style'
  | 'border-top'
  | 'border-vertical'
  | 'boy'
  | 'branding-watermark'
  | 'breakfast-dining'
  | 'brightness-1'
  | 'brightness-2'
  | 'brightness-3'
  | 'brightness-4'
  | 'brightness-5'
  | 'brightness-6'
  | 'brightness-7'
  | 'brightness-auto'
  | 'brightness-high'
  | 'brightness-low'
  | 'brightness-medium'
  | 'broadcast-on-home'
  | 'broadcast-on-personal'
  | 'broken-image'
  | 'browse-gallery'
  | 'browser-not-supported'
  | 'browser-updated'
  | 'brunch-dining'
  | 'brush'
  | 'bubble-chart'
  | 'bug-report'
  | 'build-circle'
  | 'build'
  | 'bungalow'
  | 'burst-mode'
  | 'bus-alert'
  | 'business-center'
  | 'business'
  | 'cabin'
  | 'cable'
  | 'cached'
  | 'cake'
  | 'calculate'
  | 'calendar-month'
  | 'calendar-today'
  | 'calendar-view-day'
  | 'calendar-view-month'
  | 'calendar-view-week'
  | 'call-end'
  | 'call-made'
  | 'call-merge'
  | 'call-missed-outgoing'
  | 'call-missed'
  | 'call-received'
  | 'call-split'
  | 'call-to-action'
  | 'call'
  | 'camera-alt'
  | 'camera-enhance'
  | 'camera-front'
  | 'camera-indoor'
  | 'camera-outdoor'
  | 'camera-rear'
  | 'camera-roll'
  | 'camera'
  | 'cameraswitch'
  | 'campaign'
  | 'cancel-presentation'
  | 'cancel-schedule-send'
  | 'cancel'
  | 'candlestick-chart'
  | 'car-crash'
  | 'car-rental'
  | 'car-repair'
  | 'card-giftcard'
  | 'card-membership'
  | 'card-travel'
  | 'carpenter'
  | 'cases'
  | 'casino'
  | 'cast-connected'
  | 'cast-for-education'
  | 'cast'
  | 'castle'
  | 'catching-pokemon'
  | 'category'
  | 'celebration'
  | 'cell-tower'
  | 'cell-wifi'
  | 'center-focus-strong'
  | 'center-focus-weak'
  | 'chair-alt'
  | 'chair'
  | 'chalet'
  | 'change-circle'
  | 'change-history'
  | 'charging-station'
  | 'chat-bubble-outline'
  | 'chat-bubble'
  | 'chat'
  | 'check-box-outline-blank'
  | 'check-box'
  | 'check-circle-outline'
  | 'check-circle'
  | 'check'
  | 'checklist-rtl'
  | 'checklist'
  | 'checkroom'
  | 'chevron-left'
  | 'chevron-right'
  | 'child-care'
  | 'child-friendly'
  | 'chrome-reader-mode'
  | 'church'
  | 'circle-notifications'
  | 'circle'
  | 'class'
  | 'clean-hands'
  | 'cleaning-services'
  | 'clear-all'
  | 'clear'
  | 'close-fullscreen'
  | 'close'
  | 'closed-caption-disabled'
  | 'closed-caption-off'
  | 'closed-caption'
  | 'cloud-circle'
  | 'cloud-done'
  | 'cloud-download'
  | 'cloud-off'
  | 'cloud-queue'
  | 'cloud-sync'
  | 'cloud-upload'
  | 'cloud'
  | 'co-present'
  | 'co-2'
  | 'code-off'
  | 'code'
  | 'coffee-maker'
  | 'coffee'
  | 'collections-bookmark'
  | 'collections'
  | 'color-lens'
  | 'colorize'
  | 'comment-bank'
  | 'comment'
  | 'comments-disabled'
  | 'commit'
  | 'commute'
  | 'compare-arrows'
  | 'compare'
  | 'compass-calibration'
  | 'compost'
  | 'compress'
  | 'computer'
  | 'confirmation-number'
  | 'connect-without-contact'
  | 'connected-tv'
  | 'connecting-airports'
  | 'construction'
  | 'contact-emergency'
  | 'contact-mail'
  | 'contact-page'
  | 'contact-phone'
  | 'contact-support'
  | 'contactless'
  | 'contacts'
  | 'content-copy'
  | 'content-cut'
  | 'content-paste-go'
  | 'content-paste-off'
  | 'content-paste-search'
  | 'content-paste'
  | 'contrast'
  | 'control-camera'
  | 'control-point-duplicate'
  | 'control-point'
  | 'cookie'
  | 'copy-all'
  | 'copyright'
  | 'coronavirus'
  | 'corporate-fare'
  | 'cottage'
  | 'countertops'
  | 'create-new-folder'
  | 'create'
  | 'credit-card-off'
  | 'credit-card'
  | 'credit-score'
  | 'crib'
  | 'crisis-alert'
  | 'crop-16-9'
  | 'crop-3-2'
  | 'crop-5-4'
  | 'crop-7-5'
  | 'crop-din'
  | 'crop-free'
  | 'crop-landscape'
  | 'crop-original'
  | 'crop-portrait'
  | 'crop-rotate'
  | 'crop-square'
  | 'crop'
  | 'cruelty-free'
  | 'css'
  | 'currency-bitcoin'
  | 'currency-exchange'
  | 'currency-franc'
  | 'currency-lira'
  | 'currency-pound'
  | 'currency-ruble'
  | 'currency-rupee'
  | 'currency-yen'
  | 'currency-yuan'
  | 'curtains-closed'
  | 'curtains'
  | 'cyclone'
  | 'dangerous'
  | 'dark-mode'
  | 'dashboard-customize'
  | 'dashboard'
  | 'data-array'
  | 'data-exploration'
  | 'data-object'
  | 'data-saver-off'
  | 'data-saver-on'
  | 'data-thresholding'
  | 'data-usage'
  | 'dataset-linked'
  | 'dataset'
  | 'date-range'
  | 'deblur'
  | 'deck'
  | 'dehaze'
  | 'delete-forever'
  | 'delete-outline'
  | 'delete-sweep'
  | 'delete'
  | 'delivery-dining'
  | 'density-large'
  | 'density-medium'
  | 'density-small'
  | 'departure-board'
  | 'description'
  | 'deselect'
  | 'design-services'
  | 'desk'
  | 'desktop-access-disabled'
  | 'desktop-mac'
  | 'desktop-windows'
  | 'details'
  | 'developer-board-off'
  | 'developer-board'
  | 'developer-mode'
  | 'device-hub'
  | 'device-thermostat'
  | 'device-unknown'
  | 'devices-fold'
  | 'devices-other'
  | 'devices'
  | 'dialer-sip'
  | 'dialpad'
  | 'diamond'
  | 'difference'
  | 'dining'
  | 'dinner-dining'
  | 'directions-bike'
  | 'directions-boat-filled'
  | 'directions-boat'
  | 'directions-bus-filled'
  | 'directions-bus'
  | 'directions-car-filled'
  | 'directions-car'
  | 'directions-off'
  | 'directions-railway-filled'
  | 'directions-railway'
  | 'directions-run'
  | 'directions-subway-filled'
  | 'directions-subway'
  | 'directions-transit-filled'
  | 'directions-transit'
  | 'directions-walk'
  | 'directions'
  | 'dirty-lens'
  | 'disabled-by-default'
  | 'disabled-visible'
  | 'disc-full'
  | 'discount'
  | 'display-settings'
  | 'diversity-1'
  | 'diversity-2'
  | 'diversity-3'
  | 'dns'
  | 'do-disturb-alt'
  | 'do-disturb-off'
  | 'do-disturb-on'
  | 'do-disturb'
  | 'do-not-disturb-alt'
  | 'do-not-disturb-off'
  | 'do-not-disturb-on-total-silence'
  | 'do-not-disturb-on'
  | 'do-not-disturb'
  | 'do-not-step'
  | 'do-not-touch'
  | 'dock'
  | 'document-scanner'
  | 'domain-add'
  | 'domain-disabled'
  | 'domain-verification'
  | 'domain'
  | 'done-all'
  | 'done-outline'
  | 'done'
  | 'donut-large'
  | 'donut-small'
  | 'door-back'
  | 'door-front'
  | 'door-sliding'
  | 'doorbell'
  | 'double-arrow'
  | 'downhill-skiing'
  | 'download-done'
  | 'download-for-offline'
  | 'download'
  | 'downloading'
  | 'drafts'
  | 'drag-handle'
  | 'drag-indicator'
  | 'draw'
  | 'drive-eta'
  | 'drive-file-move-rtl'
  | 'drive-file-move'
  | 'drive-file-rename-outline'
  | 'drive-folder-upload'
  | 'dry-cleaning'
  | 'dry'
  | 'duo'
  | 'dvr'
  | 'dynamic-feed'
  | 'dynamic-form'
  | 'e-mobiledata'
  | 'earbuds-battery'
  | 'earbuds'
  | 'east'
  | 'edgesensor-high'
  | 'edgesensor-low'
  | 'edit-attributes'
  | 'edit-calendar'
  | 'edit-location-alt'
  | 'edit-location'
  | 'edit-note'
  | 'edit-notifications'
  | 'edit-off'
  | 'edit-road'
  | 'edit'
  | 'egg-alt'
  | 'egg'
  | 'eject'
  | 'elderly-woman'
  | 'elderly'
  | 'electric-bike'
  | 'electric-bolt'
  | 'electric-car'
  | 'electric-meter'
  | 'electric-moped'
  | 'electric-rickshaw'
  | 'electric-scooter'
  | 'electrical-services'
  | 'elevator'
  | 'email'
  | 'emergency-recording'
  | 'emergency-share'
  | 'emergency'
  | 'emoji-emotions'
  | 'emoji-events'
  | 'emoji-food-beverage'
  | 'emoji-nature'
  | 'emoji-objects'
  | 'emoji-people'
  | 'emoji-symbols'
  | 'emoji-transportation'
  | 'energy-savings-leaf'
  | 'engineering'
  | 'enhanced-encryption'
  | 'equalizer'
  | 'error-outline'
  | 'error'
  | 'escalator-warning'
  | 'escalator'
  | 'euro-symbol'
  | 'euro'
  | 'ev-station'
  | 'event-available'
  | 'event-busy'
  | 'event-note'
  | 'event-repeat'
  | 'event-seat'
  | 'event'
  | 'exit-to-app'
  | 'expand-circle-down'
  | 'expand-less'
  | 'expand-more'
  | 'expand'
  | 'explicit'
  | 'explore-off'
  | 'explore'
  | 'exposure-neg-1'
  | 'exposure-neg-2'
  | 'exposure-plus-1'
  | 'exposure-plus-2'
  | 'exposure-zero'
  | 'exposure'
  | 'extension-off'
  | 'extension'
  | 'face-2'
  | 'face-3'
  | 'face-4'
  | 'face-5'
  | 'face-6'
  | 'face-retouching-natural'
  | 'face-retouching-off'
  | 'face'
  | 'fact-check'
  | 'factory'
  | 'family-restroom'
  | 'fast-forward'
  | 'fast-rewind'
  | 'fastfood'
  | 'favorite-border'
  | 'favorite'
  | 'fax'
  | 'featured-play-list'
  | 'featured-video'
  | 'feed'
  | 'feedback'
  | 'female'
  | 'fence'
  | 'festival'
  | 'fiber-dvr'
  | 'fiber-manual-record'
  | 'fiber-new'
  | 'fiber-pin'
  | 'fiber-smart-record'
  | 'file-copy'
  | 'file-download-done'
  | 'file-download-off'
  | 'file-download'
  | 'file-open'
  | 'file-present'
  | 'file-upload'
  | 'filter-1'
  | 'filter-2'
  | 'filter-3'
  | 'filter-4'
  | 'filter-5'
  | 'filter-6'
  | 'filter-7'
  | 'filter-8'
  | 'filter-9-plus'
  | 'filter-9'
  | 'filter-alt-off'
  | 'filter-alt'
  | 'filter-b-and-w'
  | 'filter-center-focus'
  | 'filter-drama'
  | 'filter-frames'
  | 'filter-hdr'
  | 'filter-list-off'
  | 'filter-list'
  | 'filter-none'
  | 'filter-tilt-shift'
  | 'filter-vintage'
  | 'filter'
  | 'find-in-page'
  | 'find-replace'
  | 'fingerprint'
  | 'fire-extinguisher'
  | 'fire-hydrant-alt'
  | 'fire-truck'
  | 'fireplace'
  | 'first-page'
  | 'fit-screen'
  | 'fitbit'
  | 'fitness-center'
  | 'flag-circle'
  | 'flag'
  | 'flaky'
  | 'flare'
  | 'flash-auto'
  | 'flash-off'
  | 'flash-on'
  | 'flashlight-off'
  | 'flashlight-on'
  | 'flatware'
  | 'flight-class'
  | 'flight-land'
  | 'flight-takeoff'
  | 'flight'
  | 'flip-camera-android'
  | 'flip-camera-ios'
  | 'flip-to-back'
  | 'flip-to-front'
  | 'flip'
  | 'flood'
  | 'fluorescent'
  | 'flutter-dash'
  | 'fmd-bad'
  | 'fmd-good'
  | 'folder-copy'
  | 'folder-delete'
  | 'folder-off'
  | 'folder-open'
  | 'folder-shared'
  | 'folder-special'
  | 'folder-zip'
  | 'folder'
  | 'follow-the-signs'
  | 'font-download-off'
  | 'font-download'
  | 'food-bank'
  | 'forest'
  | 'fork-left'
  | 'fork-right'
  | 'format-align-center'
  | 'format-align-justify'
  | 'format-align-left'
  | 'format-align-right'
  | 'format-bold'
  | 'format-clear'
  | 'format-color-fill'
  | 'format-color-reset'
  | 'format-color-text'
  | 'format-indent-decrease'
  | 'format-indent-increase'
  | 'format-italic'
  | 'format-line-spacing'
  | 'format-list-bulleted'
  | 'format-list-numbered-rtl'
  | 'format-list-numbered'
  | 'format-overline'
  | 'format-paint'
  | 'format-quote'
  | 'format-shapes'
  | 'format-size'
  | 'format-strikethrough'
  | 'format-textdirection-l-to-r'
  | 'format-textdirection-r-to-l'
  | 'format-underlined'
  | 'fort'
  | 'forum'
  | 'forward-10'
  | 'forward-30'
  | 'forward-5'
  | 'forward-to-inbox'
  | 'forward'
  | 'foundation'
  | 'free-breakfast'
  | 'free-cancellation'
  | 'front-hand'
  | 'fullscreen-exit'
  | 'fullscreen'
  | 'functions'
  | 'g-mobiledata'
  | 'g-translate'
  | 'gamepad'
  | 'games'
  | 'garage'
  | 'gas-meter'
  | 'gavel'
  | 'generating-tokens'
  | 'gesture'
  | 'get-app'
  | 'gif-box'
  | 'gif'
  | 'girl'
  | 'gite'
  | 'golf-course'
  | 'gpp-bad'
  | 'gpp-good'
  | 'gpp-maybe'
  | 'gps-fixed'
  | 'gps-not-fixed'
  | 'gps-off'
  | 'grade'
  | 'gradient'
  | 'grading'
  | 'grain'
  | 'graphic-eq'
  | 'grass'
  | 'grid-3-x-3'
  | 'grid-4-x-4'
  | 'grid-goldenratio'
  | 'grid-off'
  | 'grid-on'
  | 'grid-view'
  | 'group-add'
  | 'group-off'
  | 'group-remove'
  | 'group-work'
  | 'group'
  | 'groups-2'
  | 'groups-3'
  | 'groups'
  | 'h-mobiledata'
  | 'h-plus-mobiledata'
  | 'hail'
  | 'handshake'
  | 'handyman'
  | 'hardware'
  | 'hd'
  | 'hdr-auto-select'
  | 'hdr-auto'
  | 'hdr-enhanced-select'
  | 'hdr-off-select'
  | 'hdr-off'
  | 'hdr-on-select'
  | 'hdr-on'
  | 'hdr-plus'
  | 'hdr-strong'
  | 'hdr-weak'
  | 'headphones-battery'
  | 'headphones'
  | 'headset-mic'
  | 'headset-off'
  | 'headset'
  | 'healing'
  | 'health-and-safety'
  | 'hearing-disabled'
  | 'hearing'
  | 'heart-broken'
  | 'heat-pump'
  | 'height'
  | 'help-center'
  | 'help-outline'
  | 'help'
  | 'hevc'
  | 'hexagon'
  | 'hide-image'
  | 'hide-source'
  | 'high-quality'
  | 'highlight-alt'
  | 'highlight-off'
  | 'highlight'
  | 'hiking'
  | 'history-edu'
  | 'history-toggle-off'
  | 'history'
  | 'hive'
  | 'hls-off'
  | 'hls'
  | 'holiday-village'
  | 'home-max'
  | 'home-mini'
  | 'home-repair-service'
  | 'home-work'
  | 'home'
  | 'horizontal-distribute'
  | 'horizontal-rule'
  | 'horizontal-split'
  | 'hot-tub'
  | 'hotel-class'
  | 'hotel'
  | 'hourglass-bottom'
  | 'hourglass-disabled'
  | 'hourglass-empty'
  | 'hourglass-full'
  | 'hourglass-top'
  | 'house-siding'
  | 'house'
  | 'houseboat'
  | 'how-to-reg'
  | 'how-to-vote'
  | 'html'
  | 'http'
  | 'https'
  | 'hub'
  | 'hvac'
  | 'ice-skating'
  | 'icecream'
  | 'image-aspect-ratio'
  | 'image-not-supported'
  | 'image-search'
  | 'image'
  | 'imagesearch-roller'
  | 'import-contacts'
  | 'import-export'
  | 'important-devices'
  | 'inbox'
  | 'incomplete-circle'
  | 'indeterminate-check-box'
  | 'info'
  | 'input'
  | 'insert-chart-outlined'
  | 'insert-chart'
  | 'insert-comment'
  | 'insert-drive-file'
  | 'insert-emoticon'
  | 'insert-invitation'
  | 'insert-link'
  | 'insert-page-break'
  | 'insert-photo'
  | 'insights'
  | 'install-desktop'
  | 'install-mobile'
  | 'integration-instructions'
  | 'interests'
  | 'interpreter-mode'
  | 'inventory-2'
  | 'inventory'
  | 'invert-colors-off'
  | 'invert-colors'
  | 'ios-share'
  | 'iron'
  | 'iso'
  | 'javascript'
  | 'join-full'
  | 'join-inner'
  | 'join-left'
  | 'join-right'
  | 'kayaking'
  | 'kebab-dining'
  | 'key-off'
  | 'key'
  | 'keyboard-alt'
  | 'keyboard-arrow-down'
  | 'keyboard-arrow-left'
  | 'keyboard-arrow-right'
  | 'keyboard-arrow-up'
  | 'keyboard-backspace'
  | 'keyboard-capslock'
  | 'keyboard-command-key'
  | 'keyboard-control-key'
  | 'keyboard-double-arrow-down'
  | 'keyboard-double-arrow-left'
  | 'keyboard-double-arrow-right'
  | 'keyboard-double-arrow-up'
  | 'keyboard-hide'
  | 'keyboard-option-key'
  | 'keyboard-return'
  | 'keyboard-tab'
  | 'keyboard-voice'
  | 'keyboard'
  | 'king-bed'
  | 'kitchen'
  | 'kitesurfing'
  | 'label-important'
  | 'label-off'
  | 'label'
  | 'lan'
  | 'landscape'
  | 'landslide'
  | 'language'
  | 'laptop-chromebook'
  | 'laptop-mac'
  | 'laptop-windows'
  | 'laptop'
  | 'last-page'
  | 'launch'
  | 'layers-clear'
  | 'layers'
  | 'leaderboard'
  | 'leak-add'
  | 'leak-remove'
  | 'legend-toggle'
  | 'lens-blur'
  | 'lens'
  | 'library-add-check'
  | 'library-add'
  | 'library-books'
  | 'library-music'
  | 'light-mode'
  | 'light'
  | 'lightbulb-circle'
  | 'lightbulb'
  | 'line-axis'
  | 'line-style'
  | 'line-weight'
  | 'linear-scale'
  | 'link-off'
  | 'link'
  | 'linked-camera'
  | 'liquor'
  | 'list-alt'
  | 'list'
  | 'live-help'
  | 'live-tv'
  | 'living'
  | 'local-activity'
  | 'local-airport'
  | 'local-atm'
  | 'local-bar'
  | 'local-cafe'
  | 'local-car-wash'
  | 'local-convenience-store'
  | 'local-dining'
  | 'local-drink'
  | 'local-fire-department'
  | 'local-florist'
  | 'local-gas-station'
  | 'local-grocery-store'
  | 'local-hospital'
  | 'local-hotel'
  | 'local-laundry-service'
  | 'local-library'
  | 'local-mall'
  | 'local-movies'
  | 'local-offer'
  | 'local-parking'
  | 'local-pharmacy'
  | 'local-phone'
  | 'local-pizza'
  | 'local-play'
  | 'local-police'
  | 'local-post-office'
  | 'local-printshop'
  | 'local-see'
  | 'local-shipping'
  | 'local-taxi'
  | 'location-city'
  | 'location-disabled'
  | 'location-off'
  | 'location-on'
  | 'location-searching'
  | 'lock-clock'
  | 'lock-open'
  | 'lock-person'
  | 'lock-reset'
  | 'lock'
  | 'login'
  | 'logo-dev'
  | 'logout'
  | 'looks-3'
  | 'looks-4'
  | 'looks-5'
  | 'looks-6'
  | 'looks-one'
  | 'looks-two'
  | 'looks'
  | 'loop'
  | 'loupe'
  | 'low-priority'
  | 'loyalty'
  | 'lte-mobiledata'
  | 'lte-plus-mobiledata'
  | 'luggage'
  | 'lunch-dining'
  | 'lyrics'
  | 'macro-off'
  | 'mail-lock'
  | 'mail-outline'
  | 'mail'
  | 'male'
  | 'man-2'
  | 'man-3'
  | 'man-4'
  | 'man'
  | 'manage-accounts'
  | 'manage-history'
  | 'manage-search'
  | 'map'
  | 'maps-home-work'
  | 'maps-ugc'
  | 'margin'
  | 'mark-as-unread'
  | 'mark-chat-read'
  | 'mark-chat-unread'
  | 'mark-email-read'
  | 'mark-email-unread'
  | 'mark-unread-chat-alt'
  | 'markunread-mailbox'
  | 'markunread'
  | 'masks'
  | 'maximize'
  | 'media-bluetooth-off'
  | 'media-bluetooth-on'
  | 'mediation'
  | 'medical-information'
  | 'medical-services'
  | 'medication-liquid'
  | 'medication'
  | 'meeting-room'
  | 'memory'
  | 'menu-book'
  | 'menu-open'
  | 'menu'
  | 'merge-type'
  | 'merge'
  | 'message'
  | 'mic-external-off'
  | 'mic-external-on'
  | 'mic-none'
  | 'mic-off'
  | 'mic'
  | 'microwave'
  | 'military-tech'
  | 'minimize'
  | 'minor-crash'
  | 'miscellaneous-services'
  | 'missed-video-call'
  | 'mms'
  | 'mobile-friendly'
  | 'mobile-off'
  | 'mobile-screen-share'
  | 'mobiledata-off'
  | 'mode-comment'
  | 'mode-edit-outline'
  | 'mode-edit'
  | 'mode-fan-off'
  | 'mode-night'
  | 'mode-of-travel'
  | 'mode-standby'
  | 'mode'
  | 'model-training'
  | 'monetization-on'
  | 'money-off-csred'
  | 'money-off'
  | 'money'
  | 'monitor-heart'
  | 'monitor-weight'
  | 'monitor'
  | 'monochrome-photos'
  | 'mood-bad'
  | 'mood'
  | 'moped'
  | 'more-horiz'
  | 'more-time'
  | 'more-vert'
  | 'more'
  | 'mosque'
  | 'motion-photos-auto'
  | 'motion-photos-off'
  | 'motion-photos-on'
  | 'motion-photos-pause'
  | 'motion-photos-paused'
  | 'mouse'
  | 'move-down'
  | 'move-to-inbox'
  | 'move-up'
  | 'movie-creation'
  | 'movie-filter'
  | 'movie'
  | 'moving'
  | 'mp'
  | 'multiline-chart'
  | 'multiple-stop'
  | 'museum'
  | 'music-note'
  | 'music-off'
  | 'music-video'
  | 'my-location'
  | 'nat'
  | 'nature-people'
  | 'nature'
  | 'navigate-before'
  | 'navigate-next'
  | 'navigation'
  | 'near-me-disabled'
  | 'near-me'
  | 'nearby-error'
  | 'nearby-off'
  | 'nest-cam-wired-stand'
  | 'network-cell'
  | 'network-check'
  | 'network-locked'
  | 'network-ping'
  | 'network-wifi-1-bar'
  | 'network-wifi-2-bar'
  | 'network-wifi-3-bar'
  | 'network-wifi'
  | 'new-label'
  | 'new-releases'
  | 'newspaper'
  | 'next-plan'
  | 'next-week'
  | 'nfc'
  | 'night-shelter'
  | 'nightlife'
  | 'nightlight-round'
  | 'nightlight'
  | 'nights-stay'
  | 'no-accounts'
  | 'no-adult-content'
  | 'no-backpack'
  | 'no-cell'
  | 'no-crash'
  | 'no-drinks'
  | 'no-encryption-gmailerrorred'
  | 'no-encryption'
  | 'no-flash'
  | 'no-food'
  | 'no-luggage'
  | 'no-meals'
  | 'no-meeting-room'
  | 'no-photography'
  | 'no-sim'
  | 'no-stroller'
  | 'no-transfer'
  | 'noise-aware'
  | 'noise-control-off'
  | 'nordic-walking'
  | 'north-east'
  | 'north-west'
  | 'north'
  | 'not-accessible'
  | 'not-interested'
  | 'not-listed-location'
  | 'not-started'
  | 'note-add'
  | 'note-alt'
  | 'note'
  | 'notes'
  | 'notification-add'
  | 'notification-important'
  | 'notifications-active'
  | 'notifications-none'
  | 'notifications-off'
  | 'notifications-paused'
  | 'notifications'
  | 'numbers'
  | 'offline-bolt'
  | 'offline-pin'
  | 'offline-share'
  | 'oil-barrel'
  | 'on-device-training'
  | 'ondemand-video'
  | 'online-prediction'
  | 'opacity'
  | 'open-in-browser'
  | 'open-in-full'
  | 'open-in-new-off'
  | 'open-in-new'
  | 'open-with'
  | 'other-houses'
  | 'outbound'
  | 'outbox'
  | 'outdoor-grill'
  | 'outlet'
  | 'outlined-flag'
  | 'output'
  | 'padding'
  | 'pages'
  | 'pageview'
  | 'paid'
  | 'palette'
  | 'pan-tool-alt'
  | 'pan-tool'
  | 'panorama-fish-eye'
  | 'panorama-horizontal-select'
  | 'panorama-horizontal'
  | 'panorama-photosphere-select'
  | 'panorama-photosphere'
  | 'panorama-vertical-select'
  | 'panorama-vertical'
  | 'panorama-wide-angle-select'
  | 'panorama-wide-angle'
  | 'panorama'
  | 'paragliding'
  | 'park'
  | 'party-mode'
  | 'password'
  | 'pattern'
  | 'pause-circle-filled'
  | 'pause-circle-outline'
  | 'pause-circle'
  | 'pause-presentation'
  | 'pause'
  | 'payment'
  | 'payments'
  | 'pedal-bike'
  | 'pending-actions'
  | 'pending'
  | 'pentagon'
  | 'people-alt'
  | 'people-outline'
  | 'people'
  | 'percent'
  | 'perm-camera-mic'
  | 'perm-contact-calendar'
  | 'perm-data-setting'
  | 'perm-device-information'
  | 'perm-identity'
  | 'perm-media'
  | 'perm-phone-msg'
  | 'perm-scan-wifi'
  | 'person-2'
  | 'person-3'
  | 'person-4'
  | 'person-add-alt-1'
  | 'person-add-alt'
  | 'person-add-disabled'
  | 'person-add'
  | 'person-off'
  | 'person-outline'
  | 'person-pin-circle'
  | 'person-pin'
  | 'person-remove-alt-1'
  | 'person-remove'
  | 'person-search'
  | 'person'
  | 'personal-injury'
  | 'personal-video'
  | 'pest-control-rodent'
  | 'pest-control'
  | 'pets'
  | 'phishing'
  | 'phone-android'
  | 'phone-bluetooth-speaker'
  | 'phone-callback'
  | 'phone-disabled'
  | 'phone-enabled'
  | 'phone-forwarded'
  | 'phone-iphone'
  | 'phone-locked'
  | 'phone-missed'
  | 'phone-paused'
  | 'phone'
  | 'phonelink-erase'
  | 'phonelink-lock'
  | 'phonelink-off'
  | 'phonelink-ring'
  | 'phonelink-setup'
  | 'phonelink'
  | 'photo-album'
  | 'photo-camera-back'
  | 'photo-camera-front'
  | 'photo-camera'
  | 'photo-filter'
  | 'photo-library'
  | 'photo-size-select-actual'
  | 'photo-size-select-large'
  | 'photo-size-select-small'
  | 'photo'
  | 'php'
  | 'piano-off'
  | 'piano'
  | 'picture-as-pdf'
  | 'picture-in-picture-alt'
  | 'picture-in-picture'
  | 'pie-chart-outline'
  | 'pie-chart'
  | 'pin-drop'
  | 'pin-end'
  | 'pin-invoke'
  | 'pin'
  | 'pinch'
  | 'pivot-table-chart'
  | 'pix'
  | 'place'
  | 'plagiarism'
  | 'play-arrow'
  | 'play-circle-filled'
  | 'play-circle-outline'
  | 'play-circle'
  | 'play-disabled'
  | 'play-for-work'
  | 'play-lesson'
  | 'playlist-add-check-circle'
  | 'playlist-add-check'
  | 'playlist-add-circle'
  | 'playlist-add'
  | 'playlist-play'
  | 'playlist-remove'
  | 'plumbing'
  | 'plus-one'
  | 'podcasts'
  | 'point-of-sale'
  | 'policy'
  | 'poll'
  | 'polyline'
  | 'polymer'
  | 'pool'
  | 'portable-wifi-off'
  | 'portrait'
  | 'post-add'
  | 'power-input'
  | 'power-off'
  | 'power-settings-new'
  | 'power'
  | 'precision-manufacturing'
  | 'pregnant-woman'
  | 'present-to-all'
  | 'preview'
  | 'price-change'
  | 'price-check'
  | 'print-disabled'
  | 'print'
  | 'priority-high'
  | 'privacy-tip'
  | 'private-connectivity'
  | 'production-quantity-limits'
  | 'propane-tank'
  | 'propane'
  | 'psychology-alt'
  | 'psychology'
  | 'public-off'
  | 'public'
  | 'publish'
  | 'published-with-changes'
  | 'punch-clock'
  | 'push-pin'
  | 'qr-code-2'
  | 'qr-code-scanner'
  | 'qr-code'
  | 'query-builder'
  | 'query-stats'
  | 'question-answer'
  | 'question-mark'
  | 'queue-music'
  | 'queue-play-next'
  | 'queue'
  | 'quickreply'
  | 'quiz'
  | 'r-mobiledata'
  | 'radar'
  | 'radio-button-checked'
  | 'radio-button-unchecked'
  | 'radio'
  | 'railway-alert'
  | 'ramen-dining'
  | 'ramp-left'
  | 'ramp-right'
  | 'rate-review'
  | 'raw-off'
  | 'raw-on'
  | 'read-more'
  | 'real-estate-agent'
  | 'receipt-long'
  | 'receipt'
  | 'recent-actors'
  | 'recommend'
  | 'record-voice-over'
  | 'rectangle'
  | 'recycling'
  | 'redeem'
  | 'redo'
  | 'reduce-capacity'
  | 'refresh'
  | 'remember-me'
  | 'remove-circle-outline'
  | 'remove-circle'
  | 'remove-done'
  | 'remove-from-queue'
  | 'remove-moderator'
  | 'remove-red-eye'
  | 'remove-road'
  | 'remove-shopping-cart'
  | 'remove'
  | 'reorder'
  | 'repartition'
  | 'repeat-on'
  | 'repeat-one-on'
  | 'repeat-one'
  | 'repeat'
  | 'replay-10'
  | 'replay-30'
  | 'replay-5'
  | 'replay-circle-filled'
  | 'replay'
  | 'reply-all'
  | 'reply'
  | 'report-gmailerrorred'
  | 'report-off'
  | 'report-problem'
  | 'report'
  | 'request-page'
  | 'request-quote'
  | 'reset-tv'
  | 'restart-alt'
  | 'restaurant-menu'
  | 'restaurant'
  | 'restore-from-trash'
  | 'restore-page'
  | 'restore'
  | 'reviews'
  | 'rice-bowl'
  | 'ring-volume'
  | 'rocket-launch'
  | 'rocket'
  | 'roller-shades-closed'
  | 'roller-shades'
  | 'roller-skating'
  | 'roofing'
  | 'room-preferences'
  | 'room-service'
  | 'room'
  | 'rotate-90-degrees-ccw'
  | 'rotate-90-degrees-cw'
  | 'rotate-left'
  | 'rotate-right'
  | 'roundabout-left'
  | 'roundabout-right'
  | 'rounded-corner'
  | 'route'
  | 'router'
  | 'rowing'
  | 'rss-feed'
  | 'rsvp'
  | 'rtt'
  | 'rule-folder'
  | 'rule'
  | 'run-circle'
  | 'running-with-errors'
  | 'rv-hookup'
  | 'safety-check'
  | 'safety-divider'
  | 'sailing'
  | 'sanitizer'
  | 'satellite-alt'
  | 'satellite'
  | 'save-alt'
  | 'save-as'
  | 'save'
  | 'saved-search'
  | 'savings'
  | 'scale'
  | 'scanner'
  | 'scatter-plot'
  | 'schedule-send'
  | 'schedule'
  | 'schema'
  | 'school'
  | 'science'
  | 'score'
  | 'scoreboard'
  | 'screen-lock-landscape'
  | 'screen-lock-portrait'
  | 'screen-lock-rotation'
  | 'screen-rotation-alt'
  | 'screen-rotation'
  | 'screen-search-desktop'
  | 'screen-share'
  | 'screenshot-monitor'
  | 'screenshot'
  | 'scuba-diving'
  | 'sd-card-alert'
  | 'sd-card'
  | 'sd-storage'
  | 'sd'
  | 'search-off'
  | 'search'
  | 'security-update-good'
  | 'security-update-warning'
  | 'security-update'
  | 'security'
  | 'segment'
  | 'select-all'
  | 'self-improvement'
  | 'sell'
  | 'send-and-archive'
  | 'send-time-extension'
  | 'send-to-mobile'
  | 'send'
  | 'sensor-door'
  | 'sensor-occupied'
  | 'sensor-window'
  | 'sensors-off'
  | 'sensors'
  | 'sentiment-dissatisfied'
  | 'sentiment-neutral'
  | 'sentiment-satisfied-alt'
  | 'sentiment-satisfied'
  | 'sentiment-very-dissatisfied'
  | 'sentiment-very-satisfied'
  | 'set-meal'
  | 'settings-accessibility'
  | 'settings-applications'
  | 'settings-backup-restore'
  | 'settings-bluetooth'
  | 'settings-brightness'
  | 'settings-cell'
  | 'settings-ethernet'
  | 'settings-input-antenna'
  | 'settings-input-component'
  | 'settings-input-composite'
  | 'settings-input-hdmi'
  | 'settings-input-svideo'
  | 'settings-overscan'
  | 'settings-phone'
  | 'settings-power'
  | 'settings-remote'
  | 'settings-suggest'
  | 'settings-system-daydream'
  | 'settings-voice'
  | 'settings'
  | 'severe-cold'
  | 'shape-line'
  | 'share-location'
  | 'share'
  | 'shield-moon'
  | 'shield'
  | 'shop-2'
  | 'shop-two'
  | 'shop'
  | 'shopping-bag'
  | 'shopping-basket'
  | 'shopping-cart-checkout'
  | 'shopping-cart'
  | 'short-text'
  | 'shortcut'
  | 'show-chart'
  | 'shower'
  | 'shuffle-on'
  | 'shuffle'
  | 'shutter-speed'
  | 'sick'
  | 'sign-language'
  | 'signal-cellular-0-bar'
  | 'signal-cellular-4-bar'
  | 'signal-cellular-alt-1-bar'
  | 'signal-cellular-alt-2-bar'
  | 'signal-cellular-alt'
  | 'signal-cellular-connected-no-internet-0-bar'
  | 'signal-cellular-connected-no-internet-4-bar'
  | 'signal-cellular-no-sim'
  | 'signal-cellular-nodata'
  | 'signal-cellular-null'
  | 'signal-cellular-off'
  | 'signal-wifi-0-bar'
  | 'signal-wifi-4-bar-lock'
  | 'signal-wifi-4-bar'
  | 'signal-wifi-bad'
  | 'signal-wifi-connected-no-internet-4'
  | 'signal-wifi-off'
  | 'signal-wifi-statusbar-4-bar'
  | 'signal-wifi-statusbar-connected-no-internet-4'
  | 'signal-wifi-statusbar-null'
  | 'signpost'
  | 'sim-card-alert'
  | 'sim-card-download'
  | 'sim-card'
  | 'single-bed'
  | 'sip'
  | 'skateboarding'
  | 'skip-next'
  | 'skip-previous'
  | 'sledding'
  | 'slideshow'
  | 'slow-motion-video'
  | 'smart-button'
  | 'smart-display'
  | 'smart-screen'
  | 'smart-toy'
  | 'smartphone'
  | 'smoke-free'
  | 'smoking-rooms'
  | 'sms-failed'
  | 'sms'
  | 'snippet-folder'
  | 'snooze'
  | 'snowboarding'
  | 'snowmobile'
  | 'snowshoeing'
  | 'soap'
  | 'social-distance'
  | 'solar-power'
  | 'sort-by-alpha'
  | 'sort'
  | 'sos'
  | 'soup-kitchen'
  | 'source'
  | 'south-america'
  | 'south-east'
  | 'south-west'
  | 'south'
  | 'spa'
  | 'space-bar'
  | 'space-dashboard'
  | 'spatial-audio-off'
  | 'spatial-audio'
  | 'spatial-tracking'
  | 'speaker-group'
  | 'speaker-notes-off'
  | 'speaker-notes'
  | 'speaker-phone'
  | 'speaker'
  | 'speed'
  | 'spellcheck'
  | 'splitscreen'
  | 'spoke'
  | 'sports-bar'
  | 'sports-baseball'
  | 'sports-basketball'
  | 'sports-cricket'
  | 'sports-esports'
  | 'sports-football'
  | 'sports-golf'
  | 'sports-gymnastics'
  | 'sports-handball'
  | 'sports-hockey'
  | 'sports-kabaddi'
  | 'sports-martial-arts'
  | 'sports-mma'
  | 'sports-motorsports'
  | 'sports-rugby'
  | 'sports-score'
  | 'sports-soccer'
  | 'sports-tennis'
  | 'sports-volleyball'
  | 'sports'
  | 'square-foot'
  | 'square'
  | 'ssid-chart'
  | 'stacked-bar-chart'
  | 'stacked-line-chart'
  | 'stadium'
  | 'stairs'
  | 'star-border-purple-500'
  | 'star-border'
  | 'star-half'
  | 'star-outline'
  | 'star-purple-500'
  | 'star-rate'
  | 'star'
  | 'stars'
  | 'start'
  | 'stay-current-landscape'
  | 'stay-current-portrait'
  | 'stay-primary-landscape'
  | 'stay-primary-portrait'
  | 'sticky-note-2'
  | 'stop-circle'
  | 'stop-screen-share'
  | 'stop'
  | 'storage'
  | 'store-mall-directory'
  | 'store'
  | 'storefront'
  | 'storm'
  | 'straight'
  | 'straighten'
  | 'stream'
  | 'streetview'
  | 'strikethrough-s'
  | 'stroller'
  | 'style'
  | 'subdirectory-arrow-left'
  | 'subdirectory-arrow-right'
  | 'subject'
  | 'subscript'
  | 'subscriptions'
  | 'subtitles-off'
  | 'subtitles'
  | 'subway'
  | 'summarize'
  | 'superscript'
  | 'supervised-user-circle'
  | 'supervisor-account'
  | 'support-agent'
  | 'support'
  | 'surfing'
  | 'surround-sound'
  | 'swap-calls'
  | 'swap-horiz'
  | 'swap-horizontal-circle'
  | 'swap-vert'
  | 'swap-vertical-circle'
  | 'swipe-down-alt'
  | 'swipe-down'
  | 'swipe-left-alt'
  | 'swipe-left'
  | 'swipe-right-alt'
  | 'swipe-right'
  | 'swipe-up-alt'
  | 'swipe-up'
  | 'swipe-vertical'
  | 'swipe'
  | 'switch-access-shortcut-add'
  | 'switch-access-shortcut'
  | 'switch-account'
  | 'switch-camera'
  | 'switch-left'
  | 'switch-right'
  | 'switch-video'
  | 'synagogue'
  | 'sync-alt'
  | 'sync-disabled'
  | 'sync-lock'
  | 'sync-problem'
  | 'sync'
  | 'system-security-update-good'
  | 'system-security-update-warning'
  | 'system-security-update'
  | 'system-update-alt'
  | 'system-update'
  | 'tab-unselected'
  | 'tab'
  | 'table-bar'
  | 'table-chart'
  | 'table-restaurant'
  | 'table-rows'
  | 'table-view'
  | 'tablet-android'
  | 'tablet-mac'
  | 'tablet'
  | 'tag-faces'
  | 'tag'
  | 'takeout-dining'
  | 'tap-and-play'
  | 'tapas'
  | 'task-alt'
  | 'task'
  | 'taxi-alert'
  | 'temple-buddhist'
  | 'temple-hindu'
  | 'terminal'
  | 'terrain'
  | 'text-decrease'
  | 'text-fields'
  | 'text-format'
  | 'text-increase'
  | 'text-rotate-up'
  | 'text-rotate-vertical'
  | 'text-rotation-angledown'
  | 'text-rotation-angleup'
  | 'text-rotation-down'
  | 'text-rotation-none'
  | 'text-snippet'
  | 'textsms'
  | 'texture'
  | 'theater-comedy'
  | 'theaters'
  | 'thermostat-auto'
  | 'thermostat'
  | 'thumb-down-alt'
  | 'thumb-down-off-alt'
  | 'thumb-down'
  | 'thumb-up-alt'
  | 'thumb-up-off-alt'
  | 'thumb-up'
  | 'thumbs-up-down'
  | 'thunderstorm'
  | 'time-to-leave'
  | 'timelapse'
  | 'timeline'
  | 'timer-10-select'
  | 'timer-10'
  | 'timer-3-select'
  | 'timer-3'
  | 'timer-off'
  | 'timer'
  | 'tips-and-updates'
  | 'tire-repair'
  | 'title'
  | 'toc'
  | 'today'
  | 'toggle-off'
  | 'toggle-on'
  | 'token'
  | 'toll'
  | 'tonality'
  | 'topic'
  | 'tornado'
  | 'touch-app'
  | 'tour'
  | 'toys'
  | 'track-changes'
  | 'traffic'
  | 'train'
  | 'tram'
  | 'transcribe'
  | 'transfer-within-a-station'
  | 'transform'
  | 'transgender'
  | 'transit-enterexit'
  | 'translate'
  | 'travel-explore'
  | 'trending-down'
  | 'trending-flat'
  | 'trending-up'
  | 'trip-origin'
  | 'troubleshoot'
  | 'try'
  | 'tsunami'
  | 'tty'
  | 'tune'
  | 'tungsten'
  | 'turn-left'
  | 'turn-right'
  | 'turn-sharp-left'
  | 'turn-sharp-right'
  | 'turn-slight-left'
  | 'turn-slight-right'
  | 'turned-in-not'
  | 'turned-in'
  | 'tv-off'
  | 'tv'
  | 'two-wheeler'
  | 'type-specimen'
  | 'u-turn-left'
  | 'u-turn-right'
  | 'umbrella'
  | 'unarchive'
  | 'undo'
  | 'unfold-less-double'
  | 'unfold-less'
  | 'unfold-more-double'
  | 'unfold-more'
  | 'unpublished'
  | 'unsubscribe'
  | 'upcoming'
  | 'update-disabled'
  | 'update'
  | 'upgrade'
  | 'upload-file'
  | 'upload'
  | 'usb-off'
  | 'usb'
  | 'vaccines'
  | 'vape-free'
  | 'vaping-rooms'
  | 'verified-user'
  | 'verified'
  | 'vertical-align-bottom'
  | 'vertical-align-center'
  | 'vertical-align-top'
  | 'vertical-distribute'
  | 'vertical-shades-closed'
  | 'vertical-shades'
  | 'vertical-split'
  | 'vibration'
  | 'video-call'
  | 'video-camera-back'
  | 'video-camera-front'
  | 'video-chat'
  | 'video-file'
  | 'video-label'
  | 'video-library'
  | 'video-settings'
  | 'video-stable'
  | 'videocam-off'
  | 'videocam'
  | 'videogame-asset-off'
  | 'videogame-asset'
  | 'view-agenda'
  | 'view-array'
  | 'view-carousel'
  | 'view-column'
  | 'view-comfy-alt'
  | 'view-comfy'
  | 'view-compact-alt'
  | 'view-compact'
  | 'view-cozy'
  | 'view-day'
  | 'view-headline'
  | 'view-in-ar'
  | 'view-kanban'
  | 'view-list'
  | 'view-module'
  | 'view-quilt'
  | 'view-sidebar'
  | 'view-stream'
  | 'view-timeline'
  | 'view-week'
  | 'vignette'
  | 'villa'
  | 'visibility-off'
  | 'visibility'
  | 'voice-chat'
  | 'voice-over-off'
  | 'voicemail'
  | 'volcano'
  | 'volume-down'
  | 'volume-mute'
  | 'volume-off'
  | 'volume-up'
  | 'volunteer-activism'
  | 'vpn-key-off'
  | 'vpn-key'
  | 'vpn-lock'
  | 'vrpano'
  | 'wallet'
  | 'wallpaper'
  | 'warehouse'
  | 'warning-amber'
  | 'warning'
  | 'wash'
  | 'watch-later'
  | 'watch-off'
  | 'watch'
  | 'water-damage'
  | 'water-drop'
  | 'water'
  | 'waterfall-chart'
  | 'waves'
  | 'waving-hand'
  | 'wb-auto'
  | 'wb-cloudy'
  | 'wb-incandescent'
  | 'wb-iridescent'
  | 'wb-shade'
  | 'wb-sunny'
  | 'wb-twilight'
  | 'wc'
  | 'web-asset-off'
  | 'web-asset'
  | 'web-stories'
  | 'web'
  | 'webhook'
  | 'weekend'
  | 'west'
  | 'whatshot'
  | 'wheelchair-pickup'
  | 'where-to-vote'
  | 'widgets'
  | 'width-full'
  | 'width-normal'
  | 'width-wide'
  | 'wifi-1-bar'
  | 'wifi-2-bar'
  | 'wifi-calling-3'
  | 'wifi-calling'
  | 'wifi-channel'
  | 'wifi-find'
  | 'wifi-lock'
  | 'wifi-off'
  | 'wifi-password'
  | 'wifi-protected-setup'
  | 'wifi-tethering-error'
  | 'wifi-tethering-off'
  | 'wifi-tethering'
  | 'wifi'
  | 'wind-power'
  | 'window'
  | 'wine-bar'
  | 'woman-2'
  | 'woman'
  | 'work-history'
  | 'work-off'
  | 'work-outline'
  | 'work'
  | 'workspace-premium'
  | 'workspaces'
  | 'wrap-text'
  | 'wrong-location'
  | 'wysiwyg'
  | 'yard'
  | 'youtube-searched-for'
  | 'zoom-in-map'
  | 'zoom-in'
  | 'zoom-out-map'
  | 'zoom-out'
  | 'eyeglasses';
export interface MatIcon {
  name: MatIconName;
  data: string;
}
